import React from "react";
import Question from "../components/Question";
const Home = () => {
  return <Question />;
};

export default Home;
